import slick from 'slick-carousel';

$(document).ready(function () {
  $('.success-stories').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
        }
      }
    ],
  });
});


$(document).ready(function () {
  $('.slider-testimonial').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    arrows: false,
    mobileFirst: true,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: 'linear',
    draggable: false,
    swipe: false,
    responsive: [
      {
        breakpoint: 480,
      },
      {
        breakpoint: 375,
      },
      {
        breakpoint: 320,
      },
    ],
  });
});


